module.exports = __webpack_public_path__ + "static/img/格物智安工地安全管理平台操作说明-10.66e9643.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentation/格物智安工地安全管理平台操作说明-10.jpg
// module id = vVKG
// module chunks = 0